import React, {useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {webInfo} from "../../../utils/webInfo";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {catchError} from "../../../utils/helper";
import useDelete from "../../../hooks/useDelete";
import {FileUpload} from "primereact/fileupload";
import {Badge} from "primereact/badge";
import usePost from "../../../hooks/usePost";
import {Link} from "react-router-dom";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";


const HumanTable = ({products, total, selectedDepot, onPageChange, page, perPage,update,setUpdate}: any) => {
    // const {post, loading: ploading} = usePost()
    const [visible, setVisible] = useState(false);
    const [visibleConfirmation, setVisibleConfirmation] = useState(false);
    const {remove,loading:rloading} = useDelete();
    const [selectedId, setSelectedId] = useState(null);
    const {post,loading:ploading} = usePost();
    const [categoryData, setCategoryData] = useState<any>({
        id:null,
        name:"",
        image:""
    });

    const actionTemplate = (rowData: any) => {
        return <div className="flex gap-2 justify-content-center">
            <Button
                icon="pi pi-pencil"
                title="Edit"
                className="p-button-sm"
                onClick={() => {
                    setVisible(true)
                    setCategoryData({
                        id:rowData.id,
                        name:rowData.name,
                        image:rowData.image
                    })
                }}
            />
            <Button
                icon="pi pi-trash"
                title="Remove"
                className="p-button-sm p-button-danger"
                disabled
                onClick={() => {
                    setSelectedId(rowData.id);
                    setVisibleConfirmation(true);
                }}
            />
        </div>
    };
    const imageTemplate = (rowData: any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.image}`}
            alt={rowData.name}
            style={{width: "20px", borderRadius: "6px"}}
        />
    );

    const divisionBodyTemplate = () => (
        <span>{selectedDepot.name}</span>
    )
    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Remove Category</span>
        </div>
    );

    const headerElementCategoryRemove = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Update Category</span>
        </div>
    );

    const footerContentEditCategory = ()=>{
        const updateCategory = async () => {
            const url = `${webInfo.baseUrl}/api/admin/products-human-category/${categoryData.id}`;
            const formData = new FormData();
            const payload = {
                ...categoryData,
            }
            delete payload.id
            for (const key in payload) {
                if (key === "image" && typeof payload[key] === "string") {
                    continue;
                }
                formData.append(key, payload[key]);
            }
            try {
                // @ts-ignore
                const res:any = await post(url,false,formData);
                if (res.success){
                    setVisible(false);
                    setUpdate(!update)
                }
            }catch (e) {
                catchError(e)
            }
        }
        return <div>
            <Button label="Cancel" severity={'danger'} icon="pi pi-times" onClick={() => {
                setVisible(false)
                setCategoryData({id:null,name:"",image:""});
            }} autoFocus/>
            <Button label="Save" disabled={ploading} onClick={updateCategory} className="ml-2" icon="pi pi-check" autoFocus/>
        </div>
    };

    const footerContent = ()=>{
        const deleteCategory = async () => {
            const deleteUrl = `${webInfo.baseUrl}/api/admin/products-human-category/${selectedId}`;
            try {
                const res:any = await remove(deleteUrl)
                if (res.success){
                    setUpdate(!update);
                    setVisibleConfirmation(false)
                    setSelectedId(null);
                }
            }catch (e) {
                catchError(e)
            }
        }
        return <div>
            <Button label="Cancel" severity="danger" icon="pi pi-times" onClick={() => {
                setVisibleConfirmation(false)
                setSelectedId(null);
            }} autoFocus/>
            <Button label="Delete" disabled={rloading} className="ml-2" icon="pi pi-check" onClick={deleteCategory} autoFocus/>
        </div>
    };

    const defaultImagePreviewer = () => {
        return (
            <div
                className="flex align-items-center cursor-pointer"
            >
                {categoryData.image ? (
                    <div className="p-fileupload-preview flex justify-content-between items-center w-full">
                        <div className="flex">
                            <img
                                alt="Default"
                                src={`${webInfo.baseUrl}/${categoryData.image}`} height="50"/>
                            <div className="ml-2">
                                <p className="mb-2">{categoryData.image.split("/").at(-1)}</p>
                                <div className="flex align-items-center">
                                    <p className="m-0">00.00 KB</p>
                                    <Badge className="ml-2" value="Default"></Badge>
                                </div>
                            </div>
                        </div>
                        <Button onClick={()=>setCategoryData({...categoryData,image: ""})} icon="pi pi-times" className="mr-2" rounded text severity="danger" aria-label="Cancel" />
                    </div>) : (
                    <>
                        <span style={{
                            fontSize: '1em',
                            color: 'var(--text-color-secondary)'
                        }}>
                            Upload Image
                        </span>
                    </>
                )}
            </div>
        )
    }

    const onUpload = (event: any) => {
        setCategoryData({
            ...categoryData,
            image: event.target.files[0],
        });
    };

    const onRemove = () => {
        setCategoryData({
            ...categoryData,
            image: "",
        });
    };

    const categoryTemplate = (rowData:any)=>{
        const link = `/products-human?category_code=${rowData.id}`;
        return <Link className="text-gray-900 underline" style={{ cursor: "pointer" }} to={link}>
            {rowData?.name}
        </Link>
    }

    const publishStatus = (rowData: any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-human-category/${rowData?.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status) === 1 ? 0 : 1,
            }
            try {
                const res: any = await post(statusUpdateUrl, true, payload)
                if (res.success) {
                    setUpdate(!update);
                }
            } catch (e) {
                catchError(e)
            }
        }

        if (ploading) {
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
        </div>
    }

    return (
        <div>
            <Dialog visible={visibleConfirmation} modal header={headerElement} footer={footerContent} style={{ width: '30rem' }} onHide={() => {if (!visibleConfirmation) return; setVisibleConfirmation(false); }}>
                <p className='m-0'>Are you sure, deleting this item? Once you delete it won't be able to view again</p>
            </Dialog>
            <Dialog visible={visible} modal header={headerElementCategoryRemove} footer={footerContentEditCategory} style={{width: '35rem'}}
                    onHide={() => {
                        if (!visible) return;
                        setVisible(false);
                    }}>
                <div>
                    <label htmlFor="">Category Image *</label>
                    <FileUpload
                        name="demo[]"
                        className="w-full"
                        url="/api/upload"
                        multiple={false}
                        accept="image/*"
                        maxFileSize={1024*1024}
                        emptyTemplate={defaultImagePreviewer}
                        onSelect={onUpload}
                        onRemove={onRemove}
                    />
                </div>
                <div className="my-2">
                    <label htmlFor="">Category Title *</label>
                    <InputText name={'name'} value={categoryData.name} onChange={(e:any)=>setCategoryData({...categoryData,name:e.target.value})} className="w-full" placeholder="Category title"/>
                </div>
            </Dialog>
            <DataTable
                value={products}
                rows={5}
                stripedRows
            >
                <Column
                    header="Image"
                    body={imageTemplate}
                    style={{width: "100px", textAlign: "center"}}
                />
                <Column body={categoryTemplate} header="Category Name" sortable/>
                <Column
                    header="Status"
                    body={publishStatus}
                    style={{ width: "120px", textAlign: "center" }}
                />
                <Column body={divisionBodyTemplate} header="Division" sortable/>
                <Column
                    header="Actions"
                    body={actionTemplate}
                    style={{width: "120px", textAlign: "center"}}
                />
            </DataTable>
            <Paginator
                first={(page - 1) * perPage}
                rows={perPage}
                totalRecords={total}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default HumanTable;